module.exports = __webpack_public_path__ + "static/wvat-8497064ae20b7468f94c13dd784dc5af.jpg";